import styled from 'styled-components'

export const CustomModal = styled.div`
  margin-top: 60px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`
export const CrossBlock = styled.div`
  cursor: pointer;
  position: absolute;
  right: 31px;
  top: 31px;
`

export const RegisterWrapper = styled.div`
  padding-top: 30.5px;
  h5 {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 22.5px;
  }
`

export const StartButtonBlock = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

export const StartButtonText = styled.div`
  position: absolute;
  top: 12px;
  left: 55px;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
`

export const LoginTextBlock = styled.div`
  margin-bottom: 49.5px;
  text-decoration: none;
  text-align: center;
  line-height: 21px;
`

export const LoginLink = styled.a`
  text-decoration: none;
  color: #646877;
  margin-bottom: 40px;
  margin-top: 20px;
`

export const LoginText = styled.span`
  text-decoration: none;
  color: #646877;
`

export const RegisterLogin = styled.span`
  color: #1cb954;
  border-bottom: 1px dotted #1cb954;
`

export const StyledModalHeader = styled.div`
  margin-top: 10px;
  margin-left: 10px;
`
